import React from 'react';
import Teaser from '../common/Teaser/Teaser';
import { extensions } from './extensions';

// I left some code in comments in case we want to display image in modal

export default class InteractiveItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // trueLinkUrl: '',
      isVideo: false,
    };
  }

  componentDidMount() {
    const { mediaUrl, linkUrl } = this.props;
    const extPattern = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    const ext = mediaUrl && mediaUrl.match(extPattern)?.[1];
    const isVideo = extensions.includes(ext);
    const ytVideo = linkUrl && linkUrl.match('[\\?&]v=([^&#]*)');
    const ytThumbnail = ytVideo? `http://img.youtube.com/vi/${ytVideo[1]}/0.jpg` : undefined
    this.setState({ ...this.state, isVideo, ytThumbnail });
   
    // if (linkUrl.endsWith('.aspx')) {
    //   fetch(linkUrl).then((res) =>
    //     this.setState({ ...this.state, trueLinkUrl: res.url })
    //   );
    // }
  }

  render() {
    const { mediaUrl, linkUrl, description } = this.props;
    const { isVideo, ytThumbnail } = this.state;
    // const showImageModal = trueLinkUrl.includes(mediaUrl);

    return (
      <div className="flowList__item interactive-list__item">
        {isVideo ? (
          <Teaser
            localVideoUrl={mediaUrl}
            imageUrl={ytThumbnail || mediaUrl}
            teaserUrl={linkUrl}
            teaserText={description}
          />
        ) : (
          <Teaser
            imageUrl={ytThumbnail || mediaUrl}
            teaserUrl={linkUrl}
            teaserText={description}
            isYtVideo={ytThumbnail}
          />
        )}
      </div>
    );
  }
}
